import ISO6391 from 'iso-639-1'
import Vue from 'vue'

Vue.filter('number', (value) => {
  if (typeof value !== 'number') {
    return ''
  }

  return value.toLocaleString()
})

Vue.filter('localeName', (value) => {
  return ISO6391.getName(value)
})

Vue.filter('localeNativeName', (value) => {
  return ISO6391.getNativeName(value)
})
